import React from 'react';
import { Result } from 'antd';

const NotAvailablePanel = ({ message }: { message?: string }) => {
  return (
    <Result
      style={{ height: 300 }}
      status="warning"
      subTitle={message}
    />
  )
}

export default NotAvailablePanel;
